"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZLoadingLogo = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const styled_components_1 = __importDefault(require("styled-components"));
const Logo = styled_components_1.default.img.attrs(props => {
    return { src: props.theme["app-logo-color-url"] };
}) `
   height: 100px;
   justify-self: center;
   opacity: 1;
`;
const LoadingLogo = (props) => {
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: props.className },
        react_1.default.createElement(Logo, null),
        react_1.default.createElement("div", { id: "wave" },
            react_1.default.createElement("span", { className: "dot" }),
            react_1.default.createElement("span", { className: "dot" }),
            react_1.default.createElement("span", { className: "dot" }))), document.body);
};
exports.ZLoadingLogo = styled_components_1.default(LoadingLogo) `
   display: grid;
   justify-content: center;
   align-content: center;
   height: 100vh;
   width: 100vw;
   background-color: ${props => props.theme["body-background-color"]};
   div#wave {
      position: relative;
      margin-top: 20px;
      text-align: center;
      /* width: 100px;
      height: 100px; */
      margin-left: auto;
      margin-right: auto;
   }
   .dot {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      margin-right: 3px;
      background-color: ${props => props.theme["loading-dots-color"]};
      animation: wave 1.3s linear infinite;

      &:nth-child(2) {
         animation-delay: -1.1s;
      }

      &:nth-child(3) {
         animation-delay: -0.9s;
      }
   }

   @keyframes wave {
      0%,
      60%,
      100% {
         transform: initial;
      }

      30% {
         transform: translateY(-15px);
      }
   }
`;
//# sourceMappingURL=ZLoadingLogo.js.map